import type { EChartsOption } from '../echarts-types.ts';
import type { ChartConfig } from '../types.ts';
import { chartTitle, type OptionContext } from './shared.ts';

export function buildGaugeOption(
  config: Extract<ChartConfig, { type: 'gauge' }>,
  { theme, base }: OptionContext
): EChartsOption {
  const { colors, textColor, axisLineColor } = theme;
  const min = config.min ?? 0;
  const max = config.max ?? 100;
  const v = Math.min(Math.max(config.value, min), max);
  return {
    ...base,
    title: chartTitle(config.title, textColor, 'center'),
    series: [
      {
        type: 'gauge',
        min,
        max,
        center: ['50%', '58%'],
        radius: '78%',
        startAngle: 200,
        endAngle: -20,
        splitNumber: 5,
        axisLine: {
          lineStyle: {
            width: 10,
            color: [
              [0.25, colors.negative],
              [0.5, '#f59e0b'],
              [0.75, '#eab308'],
              [1, colors.positive],
            ],
          },
        },
        pointer: { itemStyle: { color: colors.foreground } },
        axisTick: {
          distance: -10,
          length: 6,
          lineStyle: { color: axisLineColor },
        },
        splitLine: {
          distance: -12,
          length: 10,
          lineStyle: { color: axisLineColor },
        },
        axisLabel: { color: textColor, fontSize: 9, distance: 14 },
        detail: {
          valueAnimation: true,
          fontSize: 18,
          fontWeight: 'bold',
          color: textColor,
          formatter: '{value}',
        },
        data: [{ value: v, name: '' }],
      },
    ],
  };
}
